<template>
  <v-card @click="changeRoute" class="d-flex flex-nowrap price-wallet align-self-center font-size-h4" flat
          :max-width="$vuetify.breakpoint.mdAndUp ? '' : 400" min-width="280"
          height="32" v-b-tooltip="'لیست تراکنش های شما'">
    <span>بودجه تازه هاي ديوار: &nbsp;</span>

    <v-spacer/>

    <span style="max-width: calc(90% - 40px);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;direction: ltr">
            {{ persian(currency(balance)) }}
        </span>

    <v-spacer/>

    <v-icon>mdi-currency-rial</v-icon>

    <v-btn color="#6cdb72" class="price-walletButton px-0" style="margin-right: 12px" min-width="32" min-height="32"
           height="32" dark depressed @click.stop="walletDialog = !walletDialog">
      <v-icon class="plus" small>
        mdi-plus
      </v-icon>
    </v-btn>

    <custom-popup v-model="walletDialog" :cons="cons" hide-overlay transition="dialog-top-transition"
                  max-width="800px" hide-confirm>
      <increase-transactions/>
    </custom-popup>

    <custom-popup v-model="tableDialog" :cons="cons1" hide-overlay hide-confirm transition="dialog-top-transition">
      <v-card-text>
        <data-table :data="data" :columns="columns"
                    :orderDir="tableProps.dir"
                    :filters="tableProps"
                    :debounce-delay="10000" :translate="translate"
                    :per-page="[10, 25, 50, 100, 400]"
                    @on-table-props-changed="reloadTable">
          <template slot="filters" slot-scope="{ tableFilters, perPage }">
            <v-row no-gutters class="px-2">
              <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                <v-select v-model="tableFilters.length" :items="perPage"
                          item-value="page" item-text="page" dense
                          :menu-props="{offsetY: true}" outlined/>
              </v-flex>
              <v-flex xs12 sm12 md3 lg3 xl3 class="p-2">
                <v-text-field outlined dense v-model="tableFilters.search"
                              label="جست و جو" append-icon="mdi-magnify"/>
              </v-flex>
            </v-row>
          </template>
        </data-table>
      </v-card-text>
    </custom-popup>
  </v-card>
</template>

<script>
import IncreaseTransactions from "./increaseTransactions";
import {getBalance, getWalletLog} from "@/utilities/wallet";

const exhale = ms =>
    new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: "WalletOpenButton",
  components: {IncreaseTransactions},
  data() {
    return {
      checking: false,
      heartbeats: [],
      walletDialog: false,
      tableDialog: false,
      wallet: {balance: 0},
      cons: {
        title: 'شارژ کیف پول'
      },
      cons1: {
        title: 'شارژ کیف پول'
      },
      data: {},
      columns: [
        {
          label: "ردیف",
          name: "row",
          transform: (data) => {
            return this.rowNumber(this.data, data);
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "مبلغ",
          name: "amount",
          transform: (data) => this.persian(this.currency(data.data.amount))
        },
        {
          label: "ساعت",
          name: "hour",
          transform: (data) => this.persian(data.data.created_at_p.split(" ")[1])
        },
        {
          label: "تاریخ",
          name: "date",
          transform: (data) => this.persian(data.data.created_at_p.split(" ")[0])
        },
        {
          label: "مانده موجودی",
          name: "balance",
          transform: (data) => this.persian(this.currency(data.data.balance))
        },
        {
          label: "توضیحات",
          name: "description",
        },

      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        filters: {
          status: null,
        },
        status: null,
        length: 10,
        column: "id",
        dir: "desc",
      },
    }
  },
  props: {
    hideInMobile: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    let classes = window.document.querySelectorAll(".price-wallet .v-input__control .v-text-field__slot *");
    for (let c of classes) {
      c.classList.add('on-scroll-shoed');
    }

    this.getBalance();
  },
  computed: {
    balance() {
      return this.wallet?.balance || 0
    },
    avg() {
      const sum = this.heartbeats.reduce((acc, cur) => acc + cur, 0)
      const length = this.heartbeats.length

      if (!sum && !length) return 0

      return Math.ceil(sum / length)
    },
  },
  created() {
    this.takePulse(false)
  },
  methods: {
    changeRoute() {
      this.tableDialog = true
    },
    heartbeat() {
      return Math.ceil(Math.random() * (120 - 80) + 80)
    },
    async takePulse(inhale = true) {
      this.checking = true

      inhale && await exhale(1000)

      this.heartbeats = Array.from({length: 20}, this.heartbeat)

      this.checking = false
    },
    getWalletLog(query = this.tableProps) {
      getWalletLog(query).then(result => {
        this.data = result.data.data;
      });
    },
    getBalance() {
      getBalance().then(result => {
        this.wallet = result.data.data;
      }).catch(_ => {
        this.wallet.balance = 0;
      });
    },
    reloadTable(tableProps = this.tableProps) {
      this.getWalletLog(tableProps);
    },
  },
  watch: {
    tableDialog(val) {
      if (val)
        this.getWalletLog();

    },
    walletDialog(val) {
      if (!val)
        this.getBalance();
    }
  }
}
</script>

<style scoped>
.header-fixed .price-wallet,
.header-fixed .price-wallet i {
  color: #fff;
}

.price-wallet {
  padding-right: 12px;
  align-items: center;
  border-radius: 6px !important;
  background-color: rgba(51, 143, 205, 0.55);
}

.price-walletButton {
  border-radius: 6px 0 0 6px !important;
}
</style>
